import React, { useEffect, useState } from 'react';

const messages = [
  'Preparing your dashboard…',
  'Loading your workspace…',
  'Fetching latest data…',
  'Almost there…',
];

const PageLoading: React.FC = () => {
  const [msgIdx, setMsgIdx] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setMsgIdx(i => (i + 1) % messages.length);
        setFade(true);
      }, 300);
    }, 2200);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-slate-50 via-white to-indigo-50/40">
      <div className="flex flex-col items-center gap-8">
        {/* Logo */}
        <img
          src="/static/media/NewLogo.png"
          onError={e => { (e.target as HTMLImageElement).style.display = 'none'; }}
          alt="Logo"
          className="h-10 object-contain opacity-90"
        />

        {/* Animated bar */}
        <div className="relative w-48 h-1 bg-slate-200 rounded-full overflow-hidden">
          <div className="absolute inset-y-0 left-0 bg-indigo-500 rounded-full animate-loading-bar" />
        </div>

        {/* Rotating dots */}
        <div className="flex items-center gap-1.5">
          {[0, 1, 2, 3].map(i => (
            <span
              key={i}
              className="w-2 h-2 rounded-full bg-indigo-400 animate-bounce"
              style={{ animationDelay: `${i * 120}ms`, animationDuration: '900ms' }}
            />
          ))}
        </div>

        {/* Message */}
        <p
          className="text-sm text-slate-500 font-medium transition-opacity duration-300"
          style={{ opacity: fade ? 1 : 0 }}
        >
          {messages[msgIdx]}
        </p>
      </div>

      <style>{`
        @keyframes loading-bar {
          0%   { left: -60%; width: 60%; }
          50%  { left: 40%;  width: 60%; }
          100% { left: 100%; width: 60%; }
        }
        .animate-loading-bar {
          animation: loading-bar 1.4s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default PageLoading;
